"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { Experience } from "@ninetailed/experience.js-next";
import { PersonalizationExperienceMapper } from "./PersonalizationExperienceMapper";
import BaselineLoadingComponent from "./BaselineLoadingComponent";
const PersonalizationExperience = props => {
  const $ = _c(31);
  const {
    dividerNeeded,
    BaselineComponent,
    id,
    value
  } = props;
  let t0;
  if ($[0] !== value?.ntExperiencesCollection?.items) {
    t0 = value?.ntExperiencesCollection?.items || [];
    $[0] = value?.ntExperiencesCollection?.items;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const rawItems = t0;
  const t1 = String(value?.sys?.id ?? id ?? "");
  let t2;
  if ($[2] !== rawItems || $[3] !== t1) {
    t2 = PersonalizationExperienceMapper(rawItems, t1);
    $[2] = rawItems;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const parsedExperiences = t2;
  let t3;
  if ($[5] !== value) {
    t3 = {
      ...value
    };
    $[5] = value;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = props?.lang;
  let t5;
  if ($[7] !== dividerNeeded || $[8] !== t3 || $[9] !== t4) {
    t5 = {
      value: t3,
      lang: t4,
      dividerNeeded
    };
    $[7] = dividerNeeded;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const defaultProps = t5;
  const t6 = props?.lang;
  const t7 = props?.homepageSlug;
  const t8 = props?.blogPrefix;
  const t9 = props?.headerElement;
  const t10 = props?.isLCP;
  const t11 = props?.isStrictLocale;
  const t12 = props?.index;
  const t13 = props?.config;
  let t14;
  if ($[11] !== dividerNeeded || $[12] !== t10 || $[13] !== t11 || $[14] !== t12 || $[15] !== t13 || $[16] !== t6 || $[17] !== t7 || $[18] !== t8 || $[19] !== t9) {
    t14 = {
      lang: t6,
      dividerNeeded,
      homepageSlug: t7,
      blogPrefix: t8,
      headerElement: t9,
      isLCP: t10,
      isStrictLocale: t11,
      index: t12,
      config: t13
    };
    $[11] = dividerNeeded;
    $[12] = t10;
    $[13] = t11;
    $[14] = t12;
    $[15] = t13;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  const passthroughProps = t14;
  if (BaselineComponent === undefined || BaselineComponent === null) {
    return null;
  }
  if (parsedExperiences?.length > 0) {
    const t15 = `${value?.sys?.id}-${id}`;
    let t16;
    if ($[21] !== BaselineComponent || $[22] !== defaultProps || $[23] !== id || $[24] !== parsedExperiences || $[25] !== passthroughProps || $[26] !== t15) {
      t16 = <Experience key={t15} {...defaultProps} id={id} component={BaselineComponent} loadingComponent={BaselineLoadingComponent} experiences={parsedExperiences} passthroughProps={passthroughProps} />;
      $[21] = BaselineComponent;
      $[22] = defaultProps;
      $[23] = id;
      $[24] = parsedExperiences;
      $[25] = passthroughProps;
      $[26] = t15;
      $[27] = t16;
    } else {
      t16 = $[27];
    }
    return t16;
  } else {
    let t15;
    if ($[28] !== BaselineComponent || $[29] !== props) {
      t15 = <BaselineComponent {...props} />;
      $[28] = BaselineComponent;
      $[29] = props;
      $[30] = t15;
    } else {
      t15 = $[30];
    }
    return t15;
  }
};
export default PersonalizationExperience;